import { render, staticRenderFns } from "./Bugs.vue?vue&type=template&id=9404e182&scoped=true"
import script from "./Bugs.vue?vue&type=script&lang=js"
export * from "./Bugs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9404e182",
  null
  
)

export default component.exports